export const MEAL = {
  BREAKFAST: 1,
  LUNCH: 2,
  DINNER: 3,
  INCLUDED_BREAKFAST: 6
}
